export const BASE_API = "https://tecno-proxy-server-0e558cc8c164.herokuapp.com/https://api.nuovopay.com";
export const BASE_API_BACK = "http://localhost:8000";
export const TOKEN = "Token 9ec3f41826604875a5161e435dc3f909";
